import React from 'react';
import PropTypes from 'prop-types';

import clubbieLogo from '../../../assets/images/clubbie_logo_full.svg';

/**
 * Shared layout for all authentication pages
 * Two-column layout: image on left, form on right
 */
export const AuthLayout = ({ children, heroImage, title, subtitle }) => {
  return (
    <div className="relative flex w-screen h-screen bg-app-bg max-w-[1512px] mx-auto">
      {/* Left Side - Hero Image */}
      <div className="hidden md:block w-1/2 h-full overflow-hidden">
        <img
          src={heroImage}
          alt="Authentication"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Right Side - Form Content */}
      <div className="w-full md:w-1/2 bg-bg-dark flex flex-col justify-center items-center p-4 md:p-10 overflow-y-auto">
        {/* Logo - Top Right */}
        <img
          src={clubbieLogo}
          alt="Clubbie"
          className="absolute top-4 right-4 md:top-6 md:right-6 w-24 md:w-32 h-auto"
        />

        {/* Content Container */}
        <div className="w-full max-w-xl flex flex-col items-center">
          {/* Title Section */}
          {(title || subtitle) && (
            <div className="text-center mb-10 w-full">
              {title && (
                <h1 className="text-4xl font-semibold text-[#FEFCEB] mb-1 font-proxima">
                  {title}
                </h1>
              )}
              {subtitle && (
                <p className="text-[13px] text-app-text-secondary font-light font-light">
                  {subtitle}
                </p>
              )}
            </div>
          )}

          {/* Form/Content */}
          <div className="w-full flex flex-col items-center gap-1.5">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

AuthLayout.propTypes = {
  children: PropTypes.node.isRequired,
  heroImage: PropTypes.string.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

export default AuthLayout;
